import { render, staticRenderFns } from "./Selectbillingpage.vue?vue&type=template&id=96ef47d4&"
import script from "./Selectbillingpage.vue?vue&type=script&lang=js&"
export * from "./Selectbillingpage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports